import type { Mood } from "mascotz/react";
import type { MascotMood } from "./types";

/**
 * Brand identity for the mascot (https://mascotz.dev).
 *
 * The seed keeps one stable character, and body/eyes/color are pinned so the
 * mascot can never drift between renders or releases. Any mascotz color name
 * or hex works here.
 */
export const MASCOT_SEED = "lyder-talk";
export const MASCOT_BODY = "pear";
export const MASCOT_EYES = "big";
export const MASCOT_COLOR = "blue";

/**
 * `MascotMood` is our own vocabulary (call sites drive practice state); mascotz
 * has its own ten moods. This is the whole translation table, so re-tuning the
 * character never means touching the 20+ components that render <Mascot />.
 *
 *   happy     → a correct answer or a nice bit of progress
 *   love      → "you're on fire": easy answers and perfect scores
 *   angry     → the answer was wrong (the bubble still keeps it kind)
 *   surprised → "no worries, let's try again"
 *   shy       → the hint: psst, it peeks and turns away
 *   dizzy     → nerves, running out of time
 *   thinking  → loading, generating, or a genuinely hard question
 */
export const MASCOT_MOOD: Record<MascotMood, Mood> = {
    idle: "idle",
    correct: "happy",
    good: "happy",
    perfect: "love",
    easy: "love",
    wrong: "angry",
    again: "surprised",
    hint: "shy",
    nervous: "dizzy",
    hard: "thinking",
    thinking: "thinking",
};